import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Banner from "../props/heading";
import Input from "../props/input";
import { postData } from "./postData";
import { emailValidation, messageValidation, nameValidation } from "./validation";


export default function Contact (){

    const apiUrl = process.env.REACT_APP_API_URL;

    // const localURL = 'http://localhost:8000/api/user/contactMe';

    const[isError, setError] = useState(false);

    const[errorMessage, setErrorMessage] = useState('');

    const navigate = useNavigate();

    const [user, setUser] = useState({
        name:'',
        email:'',
        message:'',

    });

    const [isValid, setIsValid] = useState({
        email:true,
        message:true,
        name: true
        });

    const [isLoading, setIsLoading] = useState(false);


    const handleChange = (event)=>{
        const{name, value}=event.target;
        setUser({...user, [name]:value});
        if (name === 'email' ) {
            setIsValid(prevIsValid => ({
                ...prevIsValid,
                email: emailValidation(value)
            }));
        }
        if(name === 'message'){
            setIsValid(prevIsValid => ({
                ...prevIsValid,
                message: messageValidation(value)
            }));
        }
        if (name==='name'){
            setIsValid(prevIsValid =>({
                ...prevIsValid,
                name: nameValidation(value)
            }));
        }
    }

    const handleClick = (event)=>{
        event.preventDefault();

        const allValid = Object.values(isValid).every(value => value);

        if (!allValid) {
            return; 
        }

        setIsLoading(true);
        setError(false);

        postData(apiUrl, user)
        .then((response) => {
            if (response.status === 'success') {
                setTimeout(() => {
                    navigate('/');
                }, 1000);
            } 
        })
        .catch((error) => {
            setError(true); 
            setErrorMessage(error.message);
        })
        .finally(() => {
            setIsLoading(false);
        });
    }

    return(
        
            <main className="contactMain">
                <div className="banner">
                    <Banner 
                        heading="heading"
                        title="title"
                        myTitle="Let's Connect"
                        paragraph="paragraph"
                        mission="mission"
                        myMission="Have a question, an idea, or simply want to say hello? I’m just a message away. Reach out and let's make something great together!."
                    />
                </div>

                <div className="rightArrow">
                    <div className="arrow rghtarrow">&#8594;</div>
                </div>


                <div className="contact">

                    <form className="contactForm">
                        <div className="contactName">
                            <label className="fieldLabel">Name:</label>
                            <Input 
                            className={`username ${isValid.name ? '' : 'errorMessage'}`}
                            name='name'
                            type='text'
                            placeholder='Full Name'
                            autoCapitalize='off'
                            autoCorrect='off'
                            required
                            minLength={2}
                            value={user.name}
                            onChange={handleChange}
                            />
                        </div>

                        <div className="contactEmail">
                            <label className="fieldLabel">Email:</label>
                            <Input 
                            className={`email ${isValid.email ? '' : 'errorMessage'}`}
                            type='email'
                            name='email'
                            placeholder='test@example.com'
                            autoCapitalize='off'
                            autoCorrect='off'
                            required
                            value={user.email}
                            onChange={handleChange}
                            />
                        </div>

                        <div className="contactMessage">
                            <label className="fieldLabel">Message:</label>
                            <textarea 
                                className={`message ${isValid.message ? '' : 'errorMessage'}`}
                                name='message'
                                placeholder="What’s on your mind? Let’s bring it to life"
                                autoCapitalize='off'
                                autoCorrect='off'
                                required
                                maxLength={500}
                                value={user.message}
                                onChange={handleChange}
                            />

                        </div>
                        <div className="error">
                            {isError ? ( <span className="errorMessage">{errorMessage} </span> ): (<span className="formMessage">You consent the use of your email for communication purposes.</span>)}
                        </div>
                        <div className="submitButton">
                            <button
                            className="submit"
                            type="submit"
                            onClick={handleClick}>
                                {isLoading ? 'Submitting...': 'Submit'}
                            </button>
                        
                        </div>

                    </form>
                    
                </div>

            </main>
    )
}